export default {
  brand: "#16738f",
  brandDark: "#0c3d4c",
  brandDeemph: "#667a80",
};
